import appConstants from '../../../App/AppConstants';
import isEmpty from 'lodash.isempty';
import { ExportVideoTypes } from '../../../constants/ExportVideoTypes';

// Only show the “remove watermark” button if the user is on the free plan and all the exports are either free or test exports.
export const isRemoveWatermarkPossible = (accountDetails, videoExports) => {
    if (accountDetails.subscriptionType !== appConstants.FREE_SUBSCRIPTION_TYPE) {
        return false;
    }
    if (isEmpty(videoExports)) {
        return false;
    }

    for (var i = 0; i < videoExports.length; i++) {
        var item = videoExports[i];
        if (item.type !== ExportVideoTypes.FREE_VIDEO && item.type !== ExportVideoTypes.TEST_VIDEO) {
            return false;
        }
    }
    
    return true;
};

export const getPublicVideoLink = (exportId) => {
    // TODO: Replace this condition with isProduction helper
    if (window.location.host === 'app.specterr.com') {
        return `https://specterr.com/v/${exportId}`;
    } else {
        return `${window.location.protocol}//${window.location.host}/view/export/${exportId}`;
    }
};